module.exports = __webpack_public_path__ + "static/media/signup_bg.2b2088c1.png";